import { z } from 'zod'

import { SchoolTypeSchema } from '~/@entities/SchoolSystem'

/***************** 비재원생 명단 동기화 결과 *****************/
export const GUEST_SYNC_STATUS = ['SUCCESS', 'FAILURE'] as const

export const GuestSyncStatusSchema = z.enum(GUEST_SYNC_STATUS)
export type GuestSyncStatus = z.infer<typeof GuestSyncStatusSchema>

// 입학고사 배정 대상 비재원생. 크레버스 ERP 에서 동기화된다. grade 는 학년 또는 과목 표기 문자열이다.
// legacy 타입에 있던 phone·admissionDate 는 서버(CreverseGuestResponse)가 보내지 않는 필드라 두지 않는다.
export const GuestSchema = z.object({
  id: z.number(),
  creverseStdId: z.string(),
  name: z.string(),
  schoolType: SchoolTypeSchema,
  grade: z.string(),
})
export type Guest = z.infer<typeof GuestSchema>

// 비재원생의 입학시험 회차 한 건. (guestId, admissionRefId) 가 한 행을 식별하고,
// 한 비재원생이 여러 회차를 가지면 회차마다 한 행씩 온다.
export const CreverseGuestAdmissionSchema = z.object({
  guestId: GuestSchema.shape.id,
  // 시험 회차(pbt_ref_id). 출제 시 이 값으로 배정의 회차를 지정한다.
  admissionRefId: z.string(),
  creverseStdId: GuestSchema.shape.creverseStdId,
  name: GuestSchema.shape.name,
  schoolType: SchoolTypeSchema,
  grade: GuestSchema.shape.grade,
  admissionName: z.string(),
  // 응시 예정일(YYYY-MM-DD). 서버 필드명은 admissionDate 이지만 뜻은 응시 예정일이다.
  admissionDate: z.iso.date(),
  // 만료(응시일 경과) 회차는 새 출제(취소 후 재출제 포함)를 서버가 거부한다.
  expired: z.boolean(),
  // 출제에 한 번이라도 쓰인 회차. 취소된 배정도 true 로 남는다.
  used: z.boolean(),
})
export type CreverseGuestAdmission = z.infer<typeof CreverseGuestAdmissionSchema>

// 배정·취소 대상 한 건. 비재원생과 그 비재원생의 입학시험 회차.
export const AssignTargetSchema = z.object({
  guestId: GuestSchema.shape.id,
  admissionRefId: CreverseGuestAdmissionSchema.shape.admissionRefId,
})
export type AssignTarget = z.infer<typeof AssignTargetSchema>

// 명단 동기화 결과. 서버가 함께 내는 syncedGuests(동기화된 비재원생 목록)는 앱이 목록을 다시 조회하므로 받지 않는다.
export const GuestSyncResultSchema = z.object({
  syncedAt: z.iso.datetime({ local: true }),
})
export type GuestSyncResult = z.infer<typeof GuestSyncResultSchema>

// 가장 최근 동기화 시도(성공·실패 무관). 이력이 없으면 두 필드 모두 null 이다.
export const GuestSyncLatestSchema = z.object({
  status: GuestSyncStatusSchema.nullable(),
  syncedAt: z.iso.datetime({ local: true }).nullable(),
})
export type GuestSyncLatest = z.infer<typeof GuestSyncLatestSchema>
